import {node_observable_component} from 'common/util/ComponentDecorator';
import './review.scss';
import galleryService from 'common/util/galleryService';

@node_observable_component
export default class Review {
    static classname = 'review';

    constructor($review) {
        this.$review = $review;
        this.id = this.$review.data('review_id');
        this.bindEventListeners();
    }

    bindEventListeners = () => {
        galleryService.onListOpen('.review__image', '.review__images', '.review__image-image', 'data-zoom');
    };
};
